import { render, staticRenderFns } from "./PUCImageLazyLoad.vue?vue&type=template&id=12981913&scoped=true&"
import script from "./PUCImageLazyLoad.vue?vue&type=script&lang=js&"
export * from "./PUCImageLazyLoad.vue?vue&type=script&lang=js&"
import style0 from "./PUCImageLazyLoad.vue?vue&type=style&index=0&id=12981913&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12981913",
  null
  
)

export default component.exports